var React = require('react');

function AngleDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.18424 7.15506C3.40756 6.96711 3.75702 6.95002 4.00327 7.1038L4.07383 7.15506L9.5 11.7216L14.9262 7.15506C15.1495 6.96711 15.499 6.95002 15.7452 7.1038L15.8158 7.15506C16.0391 7.34301 16.0594 7.63713 15.8767 7.84439L15.8158 7.90376L9.94479 12.8449C9.72147 13.0329 9.37201 13.05 9.12576 12.8962L9.05521 12.8449L3.18424 7.90376C2.93859 7.69701 2.93859 7.36181 3.18424 7.15506Z","fill":"white"}));
}

AngleDown.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = AngleDown;

AngleDown.default = AngleDown;
